import { useEffect, useState } from "react";
import aliCaptcha from "@/utils/ali-captcha";
import { SpinLoading, Toast } from "antd-mobile";
import "./ali-captcha.less";

export default function AliCaptcha() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const elementId = "captcha-element";
    const robotContainer = document.getElementById(elementId);
    if (!robotContainer) {
      Toast.show("验证失败，请重试");
      return;
    }
    aliCaptcha.show({
      elementId,
      onSuccess: (data: string) => {
        console.info(data);
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          window.webkit?.messageHandlers?.getSlideData?.postMessage(data);
        } else {
          window.captchaInterface?.getSlideData(data);
        }
      },
      onLoaded: () => {
        setLoading(false);
      },
    });
  }, []);

  return (
    <div className="ali-captcha-page">
      <div>
        {loading && <SpinLoading />}
        <div id="captcha-element"></div>
        <button id="button" className="login-btn" style={{ display: "none" }}>
          登录
        </button>
      </div>
    </div>
  );
}
